import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type UpdateAuditCommentsCheckProps = {
  encounterId: string;
  chartCode: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useUpdateAuditCommentsCheck({
  encounterId,
  chartCode,
  sectionCode,
  subsectionCode,
}: UpdateAuditCommentsCheckProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "UpdateAuditCommentsSubsectionCheck",
      { encounterId, chartCode, sectionCode, subsectionCode },
    ],
    () =>
      axiosChartInstance.post(
        subsectionCode
          ? `/v1/audits/subsection/check/${encounterId}/${chartCode}/${sectionCode}/${subsectionCode}`
          : `/v1/audits/section/check/${encounterId}/${chartCode}/${sectionCode}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditCommentsSectionIndicator",
          { encounterId, chartCode, sectionCode, validateSubsections: true },
        ]);
        queryClient.invalidateQueries([
          "AuditCommentsSectionIndicator",
          { encounterId, chartCode, sectionCode, validateSubsections: false },
        ]);
        if (subsectionCode) {
          queryClient.invalidateQueries([
            "AuditCommentsSubsectionIndicator",
            { encounterId, chartCode, sectionCode, subsectionCode },
          ]);
        }
      },
    }
  );
}

type UpdateAuditCommentsSharedCheckProps = {
  encounterId: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useUpdateAuditCommentsSharedCheck({
  encounterId,
  sectionCode,
  subsectionCode,
}: UpdateAuditCommentsSharedCheckProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "UpdateAuditCommentsSharedSubsectionCheck",
      { encounterId, sectionCode, subsectionCode },
    ],
    () =>
      axiosChartInstance.post(
        subsectionCode
          ? `/v1/audits/subsection/check/${encounterId}/shared/${sectionCode}/${subsectionCode}`
          : `/v1/audits/section/check/${encounterId}/shared/${sectionCode}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditCommentsSharedSectionIndicator",
          { encounterId, sectionCode, validateSubsections: true },
        ]);
        queryClient.invalidateQueries([
          "AuditCommentsSharedSectionIndicator",
          { encounterId, sectionCode, validateSubsections: false },
        ]);
        if (subsectionCode) {
          queryClient.invalidateQueries([
            "AuditCommentsSharedSubsectionIndicator",
            { encounterId, sectionCode, subsectionCode },
          ]);
        }
      },
    }
  );
}

export { useUpdateAuditCommentsCheck, useUpdateAuditCommentsSharedCheck };
